<template>
  <div id="tableContainerBody">
        <div id="tableContainer">

  <v-card style="width:100%">
    <v-card-title>
      Users
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    style="margin: 20px"
      :headers="headers"
      :items="users"
      :search="search"
    ></v-data-table>
  </v-card>
        </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'

  export default {
    data () {
      return {
        search: '',
        headers: [
          {
            text: 'User Name',
            align: 'start',
            value: 'name',
          },
          { text: 'Email', value: 'email' },
          { text: 'Date created', value: 'dateCreated' },
          { text: 'Last active', value: 'lastActive' },
          { text: 'Actions', value: 'actions' },
        ],
        users: [
          {
          name:"Miguel Cuéllar",
          email: "miguelc.95@hotmail.com",
          dateCreated: "26, 07, 2020",
          lastActive: "26, 07, 2020",
          actions: "mdi-account-edit-outline"
          }
        ],
      }
    },
    beforeMount() {
      let docRef = firebase.firestore().collection("users")

      docRef.get().then(function(doc) {
          if (doc.exists) {
              console.log("Document data:", doc.data());
          } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
          }
      }).catch(function(error) {
          console.log("Error getting document:", error);
      });
    }
  }
</script>

<style scoped>
.headerButtonBottom {
  width: 40%;
  height: 3px;
  margin-top: 10px;
  background-color: white;
}
#newTemplateButton {
  width: 192px;
  height: 48px;
  border-radius: 4px;
  box-shadow: 0 4px 10px 0 rgba(16, 156, 241, 0.24);
  background-color: #109cf1;
  color: white;
  font-size: 14px;
  border: none;
  margin-right: 30px;
}
#topContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px 20px 20px;
}
#bodyTitle {
  text-align: left;
  font-weight: bold;
  margin-left: 30px;
  font-size: 16px;
  color: #191c23;
}
#chooseTableHeader {
  width: 100%;
  height: 60px;
  background-color: white;
  color: #767675;
  display: flex;
  justify-content: left;
  align-items: center;
}
#scheduledButton {
  margin-left: 20px;
  margin-right: 50px;
}
#tableContainer {
  width: 97%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#tableContainerBody {
  background-color: #f5f6f8;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-top: 20px;
}
.filterButton {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.selected {
  color: #109cf1;
}
.selectedheaderButtonBottom {
  background-color: #109cf1;
}
.modal {
  width: 500px;
  margin: 0px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px 3px;
  transition: all 0.2s ease-in;
}
.fadeIn-enter {
  opacity: 0;
}
.fadeIn-leave-active {
  opacity: 0;
  transition: all 0.2s step-end;
}
.fadeIn-enter .modal,
.fadeIn-leave-active.modal {
  transform: scale(1.1);
}
</style>
